var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("van-switch", {
    attrs: {
      value: _vm.value,
      "active-color": _vm.activeColor,
      "inactive-color": _vm.inactiveColor,
      "active-value": _vm.activeValue,
      "inactive-value": _vm.inactiveValue,
      size: _vm.size
    },
    on: { input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d790740", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d790740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ftSwitch.vue
// module id = null
// module chunks = 